import { useTranslation } from "react-i18next";
import { Button } from "antd";

const PaymentButton = ({ disabled, loading }) => {
  const { t } = useTranslation();
  return (
    <div className="p-5 fixed bottom-0  border-t bg-white sm:bg-transparent border-gray--7 max-w-2xl  w-full  sm:border-none">
      <Button
        block
        className={`${
          disabled || loading ? "disabled-button-large" : "primary-button-large"
        } justify-center items-center`}
        disabled={disabled}
        htmlType="submit"
        loading={loading}
      >
        {t("payment.submit-receipt")}
      </Button>
    </div>
  );
};
export default PaymentButton;
